import utils from "../utils";

function init() {
	
}

window.openModal = function (button) {

	if (button) {
		var postId = button.getAttribute("data-post-id"),
			modalActive = document.getElementById("modal-post-" + postId),
			modalWrappers = document.querySelectorAll(".madal-wrapper"),
			htmlTag = document.getElementsByTagName("html")[0];

		if (modalWrappers.length > 0) {
			utils.forEach(modalWrappers, function (index, modalWrapper) {
				modalWrapper.classList.remove("show");
			});
		}

		htmlTag.classList.add("no-scroll");
		modalActive.classList.add("show");
	}
};

window.closeModal = function () {

	var modalWrappers = document.querySelectorAll(".modal-wrapper"),
		htmlTag = document.getElementsByTagName("html")[0];

	if (modalWrappers.length > 0) {
		utils.forEach(modalWrappers, function (index, modalWrapper) {
			modalWrapper.classList.remove("show");
		});
	}

	htmlTag.classList.remove("no-scroll");

};

export default { init };
